import { render, staticRenderFns } from "./EmptyContent.vue?vue&type=template&id=8d45089e&scoped=true"
import script from "./EmptyContent.vue?vue&type=script&lang=js"
export * from "./EmptyContent.vue?vue&type=script&lang=js"
import style0 from "./EmptyContent.vue?vue&type=style&index=0&id=8d45089e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d45089e",
  null
  
)

export default component.exports